/* eslint-disable global-require */
module.exports = ['ails.landingpage.records.m2', ...require('./Record/i18n')];
